import { Route, Routes } from "react-router-dom";
import AdminLayout from "./Layouts/AdminLayout";
import LoginLayout from "./Layouts/LoginLayout";
import BuxLayout from "./Layouts/BuxLayout";
import PosLayout from "./Layouts/PosLayout";
import SkladLayout from "./Layouts/SkladLayout";
import { ConfigProvider, Spin } from "antd";
import { useUiStore } from "./stores/uiStore";
import { appTheme } from "./theme";

function AppRoutes() {

    const loading = useUiStore((s) => s.loading);

    const token = localStorage.getItem('token');
    const auth = !!token;

    let authUser = localStorage.getItem('user');
    authUser = authUser ? JSON.parse(authUser) : null;

    const roleLayouts = {
        1: AdminLayout,
        2: BuxLayout,
        3: PosLayout,
        4: SkladLayout,
    };

    const RoleLayout = authUser?.role_id ? roleLayouts[authUser.role_id] : null;

    if (RoleLayout) {
        return (
            <Spin spinning={loading}>
                <Routes>
                    <Route path={'/*'} element={auth ? <RoleLayout /> : <LoginLayout />} />
                </Routes>
            </Spin>
        );
    }
    return (
        <>
            <Spin spinning={loading}>
                <Routes>
                    <Route path={'/*'} element={<LoginLayout />} />
                </Routes>
            </Spin>
        </>
    );
}

function App() {
    return (
        <ConfigProvider theme={appTheme}>
            <AppRoutes />
        </ConfigProvider>
    );
}

export default App;


